export async function getVideoStream(constraints: MediaStreamConstraints, maxRetries = 3): Promise<MediaStream> {
  try {
    console.log(`getVideoStream 시작 - maxRetries: ${maxRetries}`, JSON.stringify(constraints, null, 2));

    if (!constraints || Object.keys(constraints).length === 0) {
      throw new Error("유효하지 않은 constraints");
    }

    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    console.log("getVideoStream 성공");

    return stream;
  } catch (error) {
    console.error(`getVideoStream 에러 발생 - 남은 재시도: ${maxRetries}`, error);

    if (maxRetries <= 0) {
      console.error("getVideoStream 모든 재시도 실패");
      throw error;
    }

    await new Promise(resolve => setTimeout(resolve, 1000));
    return getVideoStream(constraints, maxRetries - 1);
  }
}
